import React from 'react';
import VendorStepLogin from "../VendorStepLogin";
import IconName from "../../../svgLogo/SvgLogo";
import HeaderResponsive from "../HeaderResponsive";
import {Link} from "react-router-dom";

const VendorLoginCode = () => {
    return (
        <div className="vendor-login-code-wrapper">
            <div className="row">
                <div className="col-lg-5 order-2 order-lg-1">
                    <VendorStepLogin/>
                </div>
                <div className="col-lg-7 order-1 order-lg-2">
                    <HeaderResponsive/>
                    <div className="send-code-wrapper d-flex flex-column align-items-center">
                        <div className="warning-send-code">
                            <p className="text">
                                توجه: ایمیل فعالسازی برای شما ارسال شده است. در صورتی که ایمیل مربوطه در Inbox شما نیست،
                                پوشه Spam ایمیل خود را نیز بررسی نمایید و حتماً در ایمیل دریافتی بر روی Report Not Spam
                                کلیک کنید تا ایمیل های ارسالی از طرف سایمان دیجیتال در پوشه Inbox شما قرار بگیرد.
                            </p>
                        </div>
                        <div className="input-code xmt-12 xmt-lg-16 position-relative">
                            <IconName name="email" className="icon input-icon position-absolute d-none d-lg-block"/>
                            <input type="text" className="input" placeholder="کد ارسال شده به ایمیلتان را وارد کنید ."/>
                            <IconName name="create"
                                      className="icon code-input-icon position-absolute d-none d-lg-block"/>
                        </div>
                        <p className="text-send-code xmt-12 xmt-lg-16">
                            کد ارسال شده به ایمیلتان را وارد کنید.
                        </p>
                        <div className="button-send-code">
                            <Link to="/vendorInformation" className="button">ثبت کد تایید</Link>
                        </div>
                        <div className="time-send-code xmt-6">
                            <IconName name="hourglass_empty" className="icon"/>
                            <span className="vendor-timer-send-code">00:00</span>
                            <span className="sec">ثانیه</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorLoginCode;
